import React from "react";

function StoryPause() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <g
        id="Pause_Icon"
        data-name="Pause Icon"
        transform="translate(-1107 -134)"
      >
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="18.5"
          cy="18.5"
          r="18.5"
          transform="translate(1107 134)"
          opacity="0.5"
        />
        <g
          id="Icon_ion-ios-pause"
          data-name="Icon ion-ios-pause"
          transform="translate(1111.517 139.35)"
        >
          <path
            id="Path_19896"
            data-name="Path 19896"
            d="M11.876,19.55H9.324A.322.322,0,0,1,9,19.23V7.07a.322.322,0,0,1,.324-.32h2.552a.322.322,0,0,1,.324.32V19.23A.322.322,0,0,1,11.876,19.55Z"
            fill="#fff"
          />
          <path
            id="Path_19897"
            data-name="Path 19897"
            d="M24.251,19.55H21.7a.322.322,0,0,1-.324-.32V7.07a.322.322,0,0,1,.324-.32h2.552a.322.322,0,0,1,.324.32V19.23A.322.322,0,0,1,24.251,19.55Z"
            transform="translate(-5.335)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default StoryPause;
